import { getCurrentSearchParams } from '../../base/historyService';

export enum EExperiment {
  V1 = 'v1',
  V2 = 'v2',
  Both = 'both',
  None = 'none',
}

export function propagateExperiment(searchParams: URLSearchParams) {
  const params = getCurrentSearchParams();
  const v1 = params.get('v1');
  if (v1) {
    searchParams.set('v1', v1);
  }
  const v2 = params.get('v2');
  if (v2) {
    searchParams.set('v2', v2);
  }
}

export function removeExperiment(searchParams: URLSearchParams) {
  searchParams.delete('v1');
  searchParams.delete('v2');
}

export default function getExperiment() {
  const params = getCurrentSearchParams();
  const v1 = params.get('v1');
  const v2 = params.get('v2');
  if (!v1 && !v2) {
    return EExperiment.None;
  }
  if (v1 && v2) {
    return EExperiment.Both;
  }
  if (v1) {
    return EExperiment.V1;
  }
  return EExperiment.V2;
}
